import ImageClass from "../../src/shell/Image";
import Question from "../../src/shell/Questions";
import { jump } from "../../src/shell/jump";
import { ann } from "../characters/Ann";
import { emily } from "../characters/Emily";
import { mc } from "../characters/MC";
import { doTransition, doWaitImageByTime } from "../helpers/helpers";
import { images } from "./images";
import { V8MorningEmilyKitchenAfter } from "./V8";

export const V8MorningEmilyKitchen = async (): Promise<any> => {
    doTransition(images.v8.V8EmilyMorning_0);
    let text = `Oh. Emily had the same idea...`;
    mc.think(text);
    if (mc.properties.emilyRelationship > 4) {
        mc.think(`I really love how she walks around the house...`);
        text = `Seeing her making food like that is like a dream come true...`;
        mc.think(text);
    }
    // ImageClass.setImage(images.v8.V8EmilyMorning_1);
    await mc.setQuestion(new Question({ text, options: { think: true }, key: `v8EmilyKitchenLookCloser` })
        .option({ title: `Look closer`, key: true })
        .option({ title: `Don't look`, key: false }));


    if (Question.globalAnswers.v8EmilyKitchenLookCloser) {
        ImageClass.setImage(images.v8.V8EmilyMorning_2);
        await mc.set((properties) => {
            properties.emilyRelationship++;
        });
        mc.think(`I can't get enough of that ass...`);
        mc.think(`I better say hey before she notices me standing here like a zombie.`);

    } else {
    }
    ImageClass.setImage(images.v8.V8EmilyMorning_3);
    mc.talk(`Good morning.`);
    ImageClass.setImage(images.v8.V8EmilyMorning_4);
    emily.talk(`${mc.name}! You are up!`);
    mc.talk(`I am, just a few minutes ago I was thinking to myself how nice it is to wake up to a calm morning.`);
    ImageClass.setImage(images.v8.V8EmilyMorning_4);
    emily.talk(`Haha, I know!`);
    emily.talk(`I'm used to you spending all day at home and now you are actually going out of the house sometimes.`);
    mc.talk(`What can I say... I've became a popular person.`);
    ImageClass.setImage(images.v8.V8EmilyMorning_4);
    emily.talk(`You were always popular! But people didn't know that yet. Haha.`);
    mc.talk(`So what are you making? I hope there is enough for two... I'm a bit hungry.`);
    if (mc.properties.emilyRelationship > 5) {
        if (Question.globalAnswers.v7AteVanessaPussy != undefined) {
            mc.talk(`I wonder if she'll offer me the same breakfast as Vanessa did...`);
        }
    }
    ImageClass.setImage(images.v8.V8EmilyMorning_4);
    emily.talk(`Hungry already? You just woke up!`);
    mc.talk(`Tell that to my stomach.`);
    emily.talk(`Haha. Anyway, I'm making a...`);
    ImageClass.setImage(images.v8.V8EmilyMorning_5);
    emily.talk(`Salad!`);
    mc.talk(`Fuck...`);
    ImageClass.setImage(images.v8.V8EmilyMorning_7);
    emily.talk(`Hey! It's good...`);
    mc.talk(`What else is on the menu?`);
    ImageClass.setImage(images.v8.V8EmilyMorning_6);
    emily.talk(`Mmm...`);
    ImageClass.setImage(images.v8.V8EmilyMorning_5);
    emily.talk(`What about some pancakes?`);
    mc.talk(`Now you're talking!`);
    ImageClass.setImage(images.v8.V8EmilyMorning_8);
    emily.talk(`Take a seat! It's gonna be ready real quick.`);
    mc.talk(`You should be careful with that knife... Someone might get the wrong idea.`);
    ImageClass.setImage(images.v8.V8EmilyMorning_4);
    emily.talk(`Haha, good! They'll know not to mess with me.`);
    doWaitImageByTime(images.v8.V8EmilyMorning_9);
    emily.talk(`You know, you are making it really hard for me to leave... Once I decide I'm ready of course.`);
    mc.talk(`Why is that?`);
    // TODO: image V8EmilyMorning_9 more movement
    emily.talk(`I love it when you keep me company...`);
    emily.talk(`I'm not here for that long and we've already gone shopping, you helped me wash my car, and now this.`);
    mc.talk(`When you say it like that... When are we gonna do something that I enjoy?`);
    emily.talk(`Alright, you make the food and I'll sit and watch.`);
    mc.talk(`Then again... I do love sitting...`);
    emily.talk(`Haha, that's what I thought.`);

    emily.talk(`Oh damn, I didn't even check if I have all the ingredients to make pancakes.`);
    ImageClass.setImage(images.v8.V8EmilyMorning_10);
    emily.talk(`Let's see...`);
    emily.talk(`Milk... Eggs...`);
    ImageClass.setImage(images.v8.V8EmilyMorning_11);
    // mc.talk(`I got used to the pictures on the fridge that now it reminds me of so many good times we had growing up.`);
    mc.think(`So many good memories growing up...`);
    mc.think(`She loved that scooter...`);
    mc.think(`Emily was so energetic... And I... Like I said. I loved sitting...`);
    mc.think(`It's funny to think we grew up in the same house, yet we are so different.`);
    mc.talk(`I can't believe these pictures are still on the fridge.`);
    emily.talk(`Right? It got me a bit emotional seeing them once I got back.`);
    mc.talk(`It's like the only thing that has changed with me is my chair...`);
    emily.talk(`Haha. Sounds about right.`);
    ImageClass.setImage(images.v8.V8EmilyMorning_12);
    emily.talk(`Where is the damn butter?`);
    if (mc.properties.emilyRelationship > 5) {
        mc.think(`I've seen some porn movies that started this way...`);
    }
    ImageClass.setImage(images.v8.V8EmilyMorning_13);
    emily.talk(`Found it!`);
    mc.talk(`So we have everything?`);
    emily.talk(`Yup!`);
    ImageClass.setImage(images.v8.V8EmilyMorning_14);
    emily.talk(`It's gonna be ready any minute now...`);


    return jump(V8MorningEmilyKitchen_2, "V8MorningEmilyKitchen_2");
};
export const V8MorningEmilyKitchen_2 = async (): Promise<any> => {
    doTransition(images.v8.V8EmilyMorning_15);
    emily.talk(`Well?`);
    ImageClass.setImage(images.v8.V8EmilyMorning_16);
    mc.talk(`Wait, I didn't even take a bite.`);
    emily.talk(`What are you waiting for? Dig in!`);
    mc.talk(`Don't worry. I'll finish before you finish your salad.`);
    ImageClass.setImage(images.v8.V8EmilyMorning_17);
    emily.talk(`Delicious salad!`);
    mc.talk(`Of course.`);
    ImageClass.setImage(images.v8.V8EmilyMorning_21);
    emily.talk(`So, what are your plans for today?`);
    ImageClass.setImage(images.v8.V8EmilyMorning_18);
    if (mc.properties.annStatus === "gf") {
        mc.talk(`To be honest, I haven't even thought about that yet.`);
        // TODO: put partials renders
        emily.talk(`What about your girlfriend?`);
        if (ann.properties.isCorrupted) {
            mc.talk(`What about her?`);
            emily.talk(`How are things going?`);
            mc.talk(`Pretty good I guess.`);
            emily.talk(`Well, that's good.`);
            emily.talk(`What do you like to do together?`);
            mc.talk(`Do you really want to hear?`);
            emily.talk(`Haha. No! You know what I mean.`);
            mc.talk(`Well, we don't exactly share the same hobbies.`);
            mc.talk(`We did have a full day of me taking pictures of her for her Insta.`);
            emily.talk(`And that's it?`);
            mc.talk(`Well... Yeah.`);

            emily.talk(`Mmm...`);
            mc.talk(`What are you thinking about?`);


        } else {
            ImageClass.setImage(images.v8.V8EmilyMorning_17);
            mc.talk(`Oh, yeah... We had a talk yesterday.`);
            ImageClass.setImage(images.v8.V8EmilyMorning_19);
            emily.talk(`Talk? That doesn't sound good.`);
            ImageClass.setImage(images.v8.V8EmilyMorning_21);
            mc.talk(`Well, she said that she might be moving to a dorm for college and she wanted me to decide what I wanna do.`);
            ImageClass.setImage(images.v8.V8EmilyMorning_18);
            emily.talk(`What did you say?`);
            mc.talk(`Nothing.`);
            ImageClass.setImage(images.v8.V8EmilyMorning_21);
            emily.talk(`Seriously?!`);
            mc.talk(`She wanted me to think about it a bit.`);
            ImageClass.setImage(images.v8.V8EmilyMorning_18);
            emily.talk(`And... Have you?`);
            ImageClass.setImage(images.v8.V8EmilyMorning_21);
            mc.talk(`Not yet...`);
            mc.talk(`But I believe there is time...`);
            mc.talk(`However, she did say she needs to go there to take some exams or something like that.\nSo we'll see how it goes.`);
            emily.talk(`I see.`);
            emily.talk(`You know... It's not something to take lightly... Long distant relationships almost never work.`);
            emily.talk(`It's fine at first... But it doesn't take long before you start thinking about other options... If you know what I mean.`);
            mc.talk(`Yes... I get you.`);

            ImageClass.setImage(images.v8.V8EmilyMorning_20);
            emily.talk(`You said she's gonna leave soon for the exams right?`);
            mc.talk(`Right.`);
            ImageClass.setImage(images.v8.V8EmilyMorning_21);
            emily.talk(`Have you planned something for the two of you?`);
            mc.talk(`Not really? Should I have?`);
            ImageClass.setImage(images.v8.V8EmilyMorning_20);
            emily.talk(`Of course!`);

            ImageClass.setImage(images.v8.V8EmilyMorning_15);
            mc.talk(`Fuck... Relationships are hard...`);
            ImageClass.setImage(images.v8.V8EmilyMorning_19);
            emily.talk(`Oh! I have an idea for you!`);
            ImageClass.setImage(images.v8.V8EmilyMorning_20);
        }
        emily.talk(`Do you remember the amusement park we used to go?`);
        mc.talk(`I do.`);
        mc.talk(`Is there a pub or a club near it?`);
        ImageClass.setImage(images.v8.V8EmilyMorning_17);
        emily.talk(`Haha.`);
        ImageClass.setImage(images.v8.V8EmilyMorning_20);
        emily.talk(`No! You should take Ann there.`);
        mc.talk(`Aren't we a bit old for that?`);
        ImageClass.setImage(images.v8.V8EmilyMorning_17);
        emily.talk(`You are never too old for that!`);
        mc.talk(`I usually love your ideas... But I don't know about this one.`);
        ImageClass.setImage(images.v8.V8EmilyMorning_21);
        emily.talk(`Trust me.`);
        ImageClass.setImage(images.v8.V8EmilyMorning_18);
        mc.talk(`Mmm... Fine.`);
        ImageClass.setImage(images.v8.V8EmilyMorning_20);
        emily.talk(`And you know what you can do afterward?`);
        mc.talk(`What?`);
        ImageClass.setImage(images.v8.V8EmilyMorning_17);
        emily.talk(`You can come back here so all three of us can hang out!`);

        ImageClass.setImage(images.v8.V8EmilyMorning_15);
        if (ann.properties.isCorrupted) {
            mc.talk(`I don't know... She is not really the social type... And I think you might've scared her the last time you two met.`);
            ImageClass.setImage(images.v8.V8EmilyMorning_18);
            emily.talk(`I know... That's why I want to fix my first impression.`);
            emily.talk(`And don't worry! I'll choose a good movie and make some popcorn... Maybe some wine if she's into it.`);
            emily.talk(`There won't be much talking! So if she is up for it, I would love to try again. No pressure though.`);
        } else {
            mc.talk(`I don't know... She is not really the social type... Even though she is trying to change.`);
            emily.talk(`Is that a yes?`);
            emily.talk(`Come on! It's going to be fun!`);
            emily.talk(`I'll choose a good movie and make some popcorn... Maybe some wine if she's into it.`);

        }
        ImageClass.setImage(images.v8.V8EmilyMorning_21);
        mc.talk(`You have been really thinking about this.`);
        ImageClass.setImage(images.v8.V8EmilyMorning_15);
        emily.talk(`It's important for me to meet her properly!`);
        ImageClass.setImage(images.v8.V8EmilyMorning_17);
        mc.talk(`Fine!`);
        mc.talk(`I'll call it: "Do What Emily Said Day".`);
        ImageClass.setImage(images.v8.V8EmilyMorning_15);
        emily.talk(`That sounds like the perfect day! Haha.`);

    } else {
        mc.talk(`Nope... I don't have any plans.`);
        mc.talk(`I think I might just chill in my room.`);
        ImageClass.setImage(images.v8.V8EmilyMorning_20);
        emily.talk(`I have a better suggestion!`);
        ImageClass.setImage(images.v8.V8EmilyMorning_21);
        mc.talk(`What's that?`);
        emily.talk(`It's been a while since we had some quality time together.`);
        ImageClass.setImage(images.v8.V8EmilyMorning_15);
        emily.talk(`How about watching a movie together?`);
        mc.talk(`That's sound nice.`);
        ImageClass.setImage(images.v8.V8EmilyMorning_17);
        emily.talk(`Great! I'll set everything up.`);

    }

    return jump(V8MorningEmilyKitchen_Finished, "V8MorningEmilyKitchen_Finished");
};

export const V8MorningEmilyKitchen_Finished = async (): Promise<any> => {
    doTransition(images.v8.V8EmilyMorning_22);
    mc.talk(`Thank you! You make the best pancakes!`);
    emily.talk(`You're welcome!`);
    emily.talk(`Well, I'll go dress and start my day... Maybe go for a ride to look for a job again.`);
    mc.talk(`Good luck!`);

    return jump(V8MorningEmilyKitchenAfter, "V8MorningEmilyKitchenAfter");
};